import { render } from "./NotificationStack.vue?vue&type=template&id=caa082fa"
import script from "./NotificationStack.vue?vue&type=script&lang=js"
export * from "./NotificationStack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrii/Documents/Projects/op-cl-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__